module.exports = "/static/assets/94b06fb716871f81bec601724e29a457.svg";